export default __webpack_public_path__ + "static/media/video_cover.ba8cec05.jpg";